import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
import { useScaleToFit } from '../hooks/useScaleToFit';
import { useIsMobile } from '../hooks/useMediaQuery';
const FRAME_WIDTH = 1280;
interface LivePreviewFrameProps {
  url: string;
  title: string;
  frameHeight?: number;
}

/**
 * Renderiza un sitio real dentro de un iframe no interactivo, escalado al
 * ancho de su contenedor. El iframe se monta solo cuando la tarjeta entra en
 * pantalla y el navegador está libre, para no competir con la carga inicial.
 */
export function LivePreviewFrame({
  url,
  title,
  frameHeight = 1000
}: LivePreviewFrameProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();
  const inView = useInView(wrapperRef, {
    once: true,
    margin: isMobile ? '150px' : '300px'
  });
  const [ready, setReady] = useState(false);
  const {
    ref,
    scale
  } = useScaleToFit(FRAME_WIDTH);
  useEffect(() => {
    if (!inView || ready) return;
    const idle = window.requestIdleCallback;
    if (typeof idle === 'function') {
      const id = idle(() => setReady(true), {
        timeout: 1500
      });
      return () => window.cancelIdleCallback?.(id);
    }
    const timer = window.setTimeout(() => setReady(true), 250);
    return () => window.clearTimeout(timer);
  }, [inView, ready]);
  return <div ref={wrapperRef} className="h-full w-full" data-id="element-177" data-mp="2t9m4hp7w05q7">
      <div ref={ref} className="h-full w-full overflow-hidden bg-mist" data-id="element-178" data-mp="25iqi57m7a2qc">
        {ready ? <iframe src={url} title={title} loading="lazy" tabIndex={-1} aria-hidden="true" sandbox="allow-same-origin allow-scripts" style={{
        width: FRAME_WIDTH,
        height: isMobile ? 700 : frameHeight,
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      }} className="pointer-events-none block border-0" data-id="element-179" data-mp="20jnadfeu5ieo" /> : <div className="flex h-full w-full items-center justify-center bg-mist" data-id="element-180" data-mp="3l1v1qvbix23u">
            <span className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-brand-blue" data-id="element-181" data-mp="2io6ta3vujuds" />
          </div>}
      </div>
    </div>;
}